<section class="facilities-section section-pad">
    <div class="container-fluid px-lg-5">
        <!-- Section Header -->
        <div class="text-center mb-5 animate-on-scroll fade-up">
            <span class="section-badge">Amenities</span>
            <h2 class="section-title mt-3">Our Facilities</h2>
            <p class="section-sub mx-auto mt-3">
                Modern amenities and resource centers designed to support student life, academic success, and holistic development.
            </p>
        </div>

        <!-- Facilities Grid -->
        <div class="facilities-grid">
            <div *ngFor="let f of facilities; let idx = index" class="facility-card animate-on-scroll fade-up" [ngClass]="'stagger-' + ((idx % 3) + 1)" [style.border-bottom]="'2px solid ' + f.color">
                <div class="facility-card-inner">
                    <div class="facility-icon" [style.color]="f.color">
                        <i [class]="f.icon"></i>
                    </div>
                    <div class="facility-name">{{ f.name }}</div>
                </div>
            </div>
        </div>
    </div>
</section>
